export default __webpack_public_path__ + "static/media/img1.f4227f01.jpg";